import { NavLink, Outlet, Link } from "react-router-dom";
import { BarChart3, Users, CreditCard, Receipt, ArrowLeft, ShieldCheck, FileText, Tag, Gift, LifeBuoy, Building2 } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/admin", label: "Resumen", icon: BarChart3, end: true, testId: "admin-nav-stats" },
  { to: "/admin/users", label: "Usuarios", icon: Users, testId: "admin-nav-users" },
  { to: "/admin/organizations", label: "Organizaciones", icon: Building2, testId: "admin-nav-organizations" },
  { to: "/admin/subscriptions", label: "Suscripciones", icon: CreditCard, testId: "admin-nav-subscriptions" },
  { to: "/admin/payments", label: "Pagos", icon: Receipt, testId: "admin-nav-payments" },
  { to: "/admin/plans", label: "Planes y precios", icon: Tag, testId: "admin-nav-plans" },
  { to: "/admin/promotions", label: "Promociones", icon: Gift, testId: "admin-nav-promotions" },
  { to: "/admin/support", label: "Soporte", icon: LifeBuoy, testId: "admin-nav-support" },
  { to: "/admin/legal", label: "Legal", icon: FileText, testId: "admin-nav-legal" },
];

export default function AdminShell() {
  return (
    <div className="h-screen w-full flex flex-col overflow-hidden relative z-10" data-testid="admin-shell">
      <header className="h-14 flex-none flex items-center gap-4 px-4 md:px-6 border-b border-white/40 dark:border-white/10 bg-white/40 dark:bg-slate-900/40 backdrop-blur-xl">
        <Link to="/" data-testid="admin-back-app" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition">
          <ArrowLeft className="h-4 w-4" /> Volver a la app
        </Link>
        <div className="ml-auto inline-flex items-center gap-2 text-sm">
          <span className="h-7 w-7 rounded-full bg-red-500/10 grid place-items-center">
            <ShieldCheck className="h-3.5 w-3.5 text-red-500" />
          </span>
          <span className="font-medium">Panel Super Admin</span>
        </div>
      </header>

      <div className="flex-1 flex overflow-hidden">
        <aside className="w-60 flex-none border-r border-white/40 dark:border-white/10 bg-white/30 dark:bg-slate-900/30 backdrop-blur-xl hidden md:flex flex-col">
          <nav className="p-3 space-y-1">
            {NAV.map(({ to, label, icon: Icon, end, testId }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                data-testid={testId}
                className={({ isActive }) => cn(
                  "flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition",
                  isActive
                    ? "bg-red-500/10 text-red-600 dark:text-red-300"
                    : "hover:bg-white/40 dark:hover:bg-white/10"
                )}
              >
                <Icon className="h-4 w-4" /> {label}
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Mobile bottom tabs */}
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-30 flex border-t border-white/40 dark:border-white/10 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl">
          {NAV.map(({ to, label, icon: Icon, end, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`${testId}-mobile`}
              className={({ isActive }) => cn(
                "flex-1 flex flex-col items-center gap-0.5 py-2 text-[11px]",
                isActive ? "text-red-600 dark:text-red-300" : "text-muted-foreground"
              )}
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>

        <main className="flex-1 overflow-y-auto kanban-scroll pb-16 md:pb-0" data-testid="admin-main">
          <div className="max-w-7xl mx-auto p-4 md:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
